import { render, staticRenderFns } from "./BasketPresentation-gt3.vue?vue&type=template&id=ca2035b0&scoped=true"
import script from "./BasketPresentation-gt3.vue?vue&type=script&lang=js"
export * from "./BasketPresentation-gt3.vue?vue&type=script&lang=js"
import style0 from "./BasketPresentation-gt3.vue?vue&type=style&index=0&id=ca2035b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2035b0",
  null
  
)

export default component.exports